import { hslToColorString, parseToHsl } from 'polished';
export function getColorSwatchFromColor(color) {
  var _parseToHsl = parseToHsl(color),
      hue = _parseToHsl.hue,
      saturation = _parseToHsl.saturation,
      lightness = _parseToHsl.lightness;

  var hoverColor = {
    hue: hue + 3,
    saturation: Math.min(1, saturation + 0.1),
    lightness: Math.max(0, lightness + 0.12)
  };
  var activeColor = {
    hue: hue,
    saturation: Math.min(1, saturation - 0.12),
    lightness: Math.max(0, lightness - 0.06)
  };
  return {
    main: color,
    hover: hslToColorString(hoverColor),
    active: hslToColorString(activeColor)
  };
}